import React, { useState } from 'react';
import { Box, Collapse, Button, Card, CardBody, Flex } from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

const JobCard = ({ job }) => {
  const [showDetails, setShowDetails] = useState(false);

  const handleToggle = () => setShowDetails(!showDetails);

  return (
    <Box p={4} width={{ base: "100%", md: "80%" }} mx="auto">
      <Card backgroundColor="rgba(42, 42, 49, 0.8)" color="white" borderRadius="15px" boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)" p={5}>
        <CardBody>
          <Flex justifyContent="space-between" alignItems="center">
            <Box fontSize="xl" fontWeight="semibold" lineHeight="tight">
              {job.title}
            </Box>
            <Button size="sm" onClick={handleToggle} isRound>
              {showDetails ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </Button>
          </Flex>
          <Collapse in={showDetails}>
            <Box mt="1" fontWeight="regular" as="h4" lineHeight="tight" noOfLines={showDetails ? null : 1}>
              {job.description}
            </Box>
          </Collapse>
        </CardBody>
      </Card>
    </Box>
  );
};

export default JobCard;
